import Login from './components/Login/Login.js';
import Dashboard from './components/Dashboard/Dashboard.js';
import ParentDashboard from './components/Dashboard/ParentDashboard.js';
import TeacherDashboard from './components/Dashboard/TeacherDashboard.js';
import Error404 from './components/Shared/Error404/Error404.js';
import ClassMaster from './components/Masters/ClassMaster/ClassMaster.js';
import SectionMaster from './components/Masters/SectionMaster/SectionMaster.js';
import TeacherMaster from './components/Masters/TeacherMaster/TeacherMaster.js';
import ViewEditTeacherDetails from './components/Masters/TeacherMaster/ViewEditTeacherMaster.js';
import StudentMaster from './components/Masters/StudentMaster/StudentMaster.js';
import ViewEditStudentDetails from './components/Masters/StudentMaster/ViewEditStudentMaster.js';
import HouseMaster from './components/Masters/HouseMaster/HouseMaster.js';
import ParentMaster from './components/Masters/ParentMaster/ParentMaster.js';
import ViewEditParentDetails from './components/Masters/ParentMaster/ViewEditParentMaster.js';
import ClassConfiguration from './components/Configuration/Class/Class.js';
import IdCardTemplateConfiguration from './components/Configuration/IdCardTemplate/IdCardTemplate.js';
import EditProfile from './components/Profile/EditProfile.js';
import IdCardMaster from './components/Generator/IdCard/IdCardMaster.js';
import SubjectMaster from './components/Masters/SubjectMaster/SubjectMaster.js';
import ProfileConfiguration from './components/Configuration/ProfileConfiguration/ProfileConfiguration.js';
import AcademicCalendarTemplate from './components/Configuration/AcademicCalendar/AcademicCalander.js';
import TimeTableConfiguration from './components/Configuration/TimeTable/TimeTable.js';
import EditClassTimeTable from './components/Configuration/TimeTable/EditClassTimeTable.js';
import EditTeacherTimeTable from './components/Configuration/TimeTable/EditTeacherTimeTable.js';
import ShiftMaster from './components/Masters/ShiftMaster/ShiftMaster.js';
import LeaveReasonMaster from './components/Masters/LeaveReasonMaster/LeaveReasonMaster.js';
import ThemeMaster from './components/Masters/ThemeMaster/ThemeMaster.js';
import FeeMaster from './components/Masters/FeeMaster/FeeMaster.js';
import Attendance from './components/Attendance/ViewAttendance.js';
import TakeAttendance from './components/Attendance/TakeAttendance.js';
import TermMaster from './components/Masters/TermMaster/TermMaster.js';
import StopMaster from './components/Masters/StopMaster/StopMaster.js';
import GradeTemplate from './components/Configuration/GradeTemplate/GradeTemplate.js';
import CoScholasticMaster from './components/Masters/Co-ScholasticMaster/Co-ScholasticMaster.js';
import ExamTemplate from './components/Configuration/ExamTemplate/ExamTemplate.js';
import TypeMaster from './components/Masters/TypeMaster/TypeMaster.js';
import CoScholasticTemplateConfiguration from './components/Configuration/CoScholasticTemplate/CoScholasticTemplate.js';
import CoScholasticGradeTemplateConfiguration from './components/Configuration/CoScholasticGradeTemplate/CoScholasticGradeTemplate.js';
import RoomMaster from './components/Masters/RoomMaster/RoomMaster.js';
import ClassNoMaster from './components/Masters/ClassNoMaster/ClassNoMaster.js';
import ExamSchedule from './components/Generator/ExamSchedule/ExamSchedule.js';
import GeneralConfiguration from './components/Configuration/General/GeneralConfiguration.js';
import Examination from './components/Grading/Examination/Examination.js';
import ExamMarksEntry from './components/Grading/Examination/ExamMarksEntry.js';
import FeeStructureConfiguration from './components/Configuration/FeeStructure/FeeStructure.js';
import ResultTemplateConfiguration from './components/Configuration/ResultTemplateConfiguration/ResultTemplateConfiguration.js';
import ResultGenerator from './components/Generator/ResultGenerator/ResultGenerator.js';
import HallTicketTemplate from './components/Configuration/HallTicketTemplate/HallTicketTemplate.js';
import HallTicketGenerator from './components/Generator/HallTicketGenerator/HallTicketGenerator.js';
import CoScholasticGrading from './components/Grading/CoScholasticGrading/CoScholasticGrading.js';
import CoScholasticGradeEntry from './components/Grading/CoScholasticGrading/CoScholasticGradingEntry.js';
import GraceConfiguration from './components/Configuration/GraceConfiguration/GraceConfiguration.js';
import GraceMarks from './components/Grading/GraceMarks/GraceMarks.js';
import GraceMarksEntry from './components/Grading/GraceMarks/GraceMarksEntry.js';
import ClassConfig from './components/Configuration/Class/ClassConfiguration.js';
import StudentList from './components/Configuration/Class/StudentList.js';
import ManageStudentPhotos from './components/Configuration/ManageStudentPhotos/ManageStudentPhotos.js';
import UpdatePhotos from './components/Configuration/UpdatePhotos/UpdatePhotos.js';
import UpdatePhotosEntry from './components/Configuration/UpdatePhotos/UpdatePhotosEntry.js';
import ChildrenList from './components/ChildreenList/ChildreenList.js';
import OTPLogin from './components/OTPLogin/OTPLogin.js';
import AcademicCalendarSpecificTemplate from './components/Configuration/AcademicCalendarSpecific/AcademicCalanderSpecific.js';
import ParentAcademicCalendar from './components/Attendance/ParentAttendanceView.js';
import StaffAttendance from './components/Attendance/StaffAttendance.js';
import ParentResultView from './components/Grading/ResultView/ResultView.js';
import FeeTemplateConfiguration from './components/Configuration/FeeTemplate/FeeTemplate.js';
import FeeCollection from './components/FeeCollection/FeeCollection.js';
import PaymentConfig from './components/Configuration/PaymentConfig/PaymentConfig.js';
import FeePayment from './components/FeePayment/FeePayment.js';
import AnnouncementPage from './components/Announcement/Announcement.js';
import LMSPage from './components/LMS/LMS.js';
import LearningResourcesPage from './components/LearningResources/LearningResources.js';
import NotificationList from './components/Notification/NotificationList.js';
import GeofenceConfiguration from './components/Configuration/GeofenceConfiguration/GeofenceConfiguration.js';
import MarkMyAttendance from './components/Attendance/MarkMyAttendance.js';
import AttendanceTypeConfiguration from './components/Configuration/AttendanceTypeConfiguration/AttendanceTypeConfiguration.js';
import AttendanceReport from './components/Reports/AttendanceReport.js';
import ExamReport from './components/Reports/ExamReport.js';
import UserAccessManagement from './components/UserManagement/UserAccessManagement.js';

var dashRoutes = [
    {
        path: "/",
        name: "Login",
        component: Login,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Login'
        },
        isPreventedRoute: true
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Login'
        },
        isPreventedRoute: true
    },
    {
        path: "/otp-login",
        name: "OTP-Login",
        component: OTPLogin,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | OTP Login'
        },
        isPreventedRoute: true
    },
    {
        path: "/childreen-list",
        name: "ChildreenList",
        component: ChildrenList,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ChildreenList'
        },
        isPreventedRoute: false
    },
    {
        path: "/404Error",
        name: "Error404",
        component: Error404,
        icon: "",
        invisible: false,
        meta: {
            title: 'Page not found'
        },
        isShared: true
    },

    /** Add all protected routing (requires session) here */
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Dashboard'
        },
        isPreventedRoute: false
    },
    {
        path: "/parent-dashboard",
        name: "ParentDashboard",
        component: ParentDashboard,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Parent Dashboard'
        },
        isPreventedRoute: false
    },
    {
        path: "/teacher-dashboard",
        name: "TeacherDashboard",
        component: TeacherDashboard,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Teacher Dashboard'
        },
        isPreventedRoute: false
    },
    {
        path: "/edit-profile",
        name: "EditProfile",
        component: EditProfile,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Edit Profile'
        },
        isPreventedRoute: false
    },
    {
        path: "/class-master",
        name: "ClassMaster",
        component: ClassMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ClassMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/section-master",
        name: "SectionMaster",
        component: SectionMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | SectionMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/teacher-master",
        name: "TeacherMaster",
        component: TeacherMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | TeacherMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/viewEdit-teacher-master",
        name: "ViewEditTeacherMaster",
        component: ViewEditTeacherDetails,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ViewEditTeacherDetails'
        },
        isPreventedRoute: false
    },
    {
        path: "/student-master",
        name: "StudentMaster",
        component: StudentMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | StudentMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/viewEdit-student-master",
        name: "ViewEditStudentMaster",
        component: ViewEditStudentDetails,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ViewEditStudentDetails'
        },
        isPreventedRoute: false
    },
    {
        path: "/house-master",
        name: "HouseMaster",
        component: HouseMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | HouseMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/parent-master",
        name: "ParentMaster",
        component: ParentMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ParentMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/viewEdit-parent-master",
        name: "ViewEditParentMaster",
        component: ViewEditParentDetails,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ViewEditParentMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/class-configuration",
        name: "ClassConfiguration",
        component: ClassConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ClassConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/class-configuration-details",
        name: "ClassConfigurationDetails",
        component: ClassConfig,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ClassConfigurationDetails'
        },
        isPreventedRoute: false
    },
    {
        path: "/studentList",
        name: "Student List",
        component: StudentList,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | StudentList'
        },
        isPreventedRoute: false
    },
    {
        path: "/id-card-template-configuration",
        name: "IdCardTemplateConfiguration",
        component: IdCardTemplateConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | IdCardTemplateConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/id-card-generator",
        name: "IdCardGenerator",
        component: IdCardMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | IdCardGenerator'
        },
        isPreventedRoute: false
    },
    {
        path: "/subject-master",
        name: "SubjectMaster",
        component: SubjectMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | SubjectMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/shift-master",
        name: "ShiftMaster",
        component: ShiftMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ShiftMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/profile-configuration",
        name: "ProfileConfiguration",
        component: ProfileConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ProfileConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/academic-calendar-template",
        name: "AcademicCalendarTemplate",
        component: AcademicCalendarTemplate,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | AcademicCalendarTemplate'
        },
        isPreventedRoute: false
    },
    {
        path: "/academic-calendar-specific",
        name: "AcademicCalendarSpecific",
        component: AcademicCalendarSpecificTemplate,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Holiday Announcement'
        },
        isPreventedRoute: false
    },
    {
        path: "/parent-attandence-view",
        name: "ParentAcademicCalendar",
        component: ParentAcademicCalendar,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Attendance view'
        },
        isPreventedRoute: false
    },
    {
        path: "/time-table-configuration",
        name: "TimeTable",
        component: TimeTableConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | TimeTableConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/edit-class-time-table",
        name: "EditClassTimeTable",
        component: EditClassTimeTable,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | EditClassTimeTable'
        },
        isPreventedRoute: false
    },
    {
        path: "/edit-teacher-time-table",
        name: "EditTeacherTimeTable",
        component: EditTeacherTimeTable,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | EditTeacherTimeTable'
        },
        isPreventedRoute: false
    },
    {
        path: "/leave-reason-master",
        name: "LeaveReasonMaster",
        component: LeaveReasonMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | LeaveReasonMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/theme-master",
        name: "ThemeMaster",
        component: ThemeMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ThemeMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/fee-master",
        name: "FeeMaster",
        component: FeeMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | FeeMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/attendance",
        name: "Attendance",
        component: Attendance,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Attendance'
        },
        isPreventedRoute: false
    },
    {
        path: "/staff-attendance",
        name: "StaffAttendance",
        component: StaffAttendance,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Staff Attendance'
        },
        isPreventedRoute: false
    },
    {
        path: "/fee-template",
        name: "FeeTemplate",
        component: FeeTemplateConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Fee Template'
        },
        isPreventedRoute: false
    },
    {
        path: "/fee-collection",
        name: "FeeCollection",
        component: FeeCollection,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Fee Collection'
        },
        isPreventedRoute: false
    },
    {
        path: "/payment-config",
        name: "PaymentConfig",
        component: PaymentConfig,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Payment Configuration'
        },
        isPreventedRoute: false
    },
    {
        path: "/fee-payment",
        name: "FeePayment",
        component: FeePayment,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Fee Payment'
        },
        isPreventedRoute: false
    },
    {
        path: "/announcement",
        name: "Announcement",
        component: AnnouncementPage,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Announcement'
        },
        isPreventedRoute: false
    },
    {
        path: "/lms",
        name: "LMS",
        component: LMSPage,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | LMS'
        },
        isPreventedRoute: false
    },
    {
        path: "/learning-resources",
        name: "Learning Resources",
        component: LearningResourcesPage,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Learning Resources'
        },
        isPreventedRoute: false
    },
    {
        path: "/notifications",
        name: "Notifications",
        component: NotificationList,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Notifications'
        },
        isPreventedRoute: false
    },
    {
        path: "/taken-attendance",
        name: "TakeAttendance",
        component: TakeAttendance,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Take Attendance'
        },
        isPreventedRoute: false
    },
    {
        path: "/term-master",
        name: "TermMaster",
        component: TermMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Term Master'
        },
        isPreventedRoute: false
    },
    {
        path: "/stop-master",
        name: "StopMaster",
        component: StopMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Stop Master'
        },
        isPreventedRoute: false
    },
    {
        path: "/grade-master",
        name: "GradeTemplate",
        component: GradeTemplate,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Grade Template'
        },
        isPreventedRoute: false
    },
    {
        path: "/co-scholastic-master",
        name: "CoScholasticMaster",
        component: CoScholasticMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Co-Scholastic Master'
        },
        isPreventedRoute: false
    },
    {
        path: "/exam-master",
        name: "ExamTemplate",
        component: ExamTemplate,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Exam Template'
        },
        isPreventedRoute: false
    },
    {
        path: "/type-master",
        name: "TypeMaster",
        component: TypeMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | TypeMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/co-scholastic-template",
        name: "CoScholasticTemplate",
        component: CoScholasticTemplateConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Co-Scholastic Template'
        },
        isPreventedRoute: false
    },
    {
        path: "/room-master",
        name: "RoomMaster",
        component: RoomMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | RoomMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/classNo-master",
        name: "ClassNoMaster",
        component: ClassNoMaster,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ClassNoMaster'
        },
        isPreventedRoute: false
    },
    {
        path: "/exam-schedule",
        name: "ExamSchedule",
        component: ExamSchedule,
        icon: "pi-calendar-plus",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ExamSchedule'
        },
        isPreventedRoute: false
    },
    {
        path: "/general-configuration",
        name: "GeneralConfiguration",
        component: GeneralConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | GenearalConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/examination",
        name: "Examation",
        component: Examination,
        icon: "pi pi-user",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Examination'
        },
        isPreventedRoute: false
    },
    {
        path: "/examination-marks",
        name: "ExamationMarks",
        component: ExamMarksEntry,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Examination Marks'
        },
        isPreventedRoute: false
    },
    {
        path: "/fee-structure",
        name: "FeeStructure",
        component: FeeStructureConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Fee Structure'
        },
        isPreventedRoute: false
    },
    {
        path: "/result-template",
        name: "ResultTemplate",
        component: ResultTemplateConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Result Template'
        },
        isPreventedRoute: false
    },
    {
        path: "/result-generator",
        name: "ResultGenerator",
        component: ResultGenerator,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ResultGenerator'
        },
        isPreventedRoute: false
    },
    {
        path: "/hall-ticket-template",
        name: "HallTicketTemplate",
        component: HallTicketTemplate,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Hall Ticket Template'
        },
        isPreventedRoute: false
    },
    {
        path: "/hall-ticket-generator",
        name: "HallTicketGenerator",
        component: HallTicketGenerator,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Hall Ticket Generator'
        },
        isPreventedRoute: false
    },
    {
        path: "/co-scholastic-grade-template",
        name: "CoScholasticGradeTemplate",
        component: CoScholasticGradeTemplateConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | CoScholasticGradeTemplate'
        },
        isPreventedRoute: false
    },
    {
        path: "/co-scholastic-grading",
        name: "CoScholasticGrading",
        component: CoScholasticGrading,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | CoScholasticGrading'
        },
        isPreventedRoute: false
    },
    {
        path: "/co-scholastic-entry",
        name: "CoScholasticEntry",
        component: CoScholasticGradeEntry,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | CoScholasticGradingEntry'
        },
        isPreventedRoute: false
    },
    {
        path: "/grace-mark-configuration",
        name: "GraceMarkConfiguration",
        component: GraceConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | GraceMarkConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/grace-mark",
        name: "GraceMark",
        component: GraceMarks,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | GraceMarks'
        },
        isPreventedRoute: false
    },
    {
        path: "/grace-marks-entry",
        name: "GraceMarksEntry",
        component: GraceMarksEntry,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | GraceMarksEntry'
        },
        isPreventedRoute: false
    },
    {
        path: "/manage-student-photos",
        name: "ManageStudentPhotos",
        component: ManageStudentPhotos,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | ManageStudentPhotos'
        },
        isPreventedRoute: false
    },
    {
        path: "/update-photos",
        name: "UpdatePhotos",
        component: UpdatePhotos,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | UpdatePhotos'
        },
        isPreventedRoute: false
    },
    {
        path: "/update-photos-entry",
        name: "UpdateStudentPhotos",
        component: UpdatePhotosEntry,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | UpdateStudentPhotos'
        },
        isPreventedRoute: false
    },
    {
        path: "/result-view",
        name: "ResultView",
        component: ParentResultView,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Result View'
        },
        isPreventedRoute: false
    },
    {
        path: "/geofence-configuration",
        name: "GeofenceConfiguration",
        component: GeofenceConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | GeofenceConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/mark-my-attendance",
        name: "MarkMyAttendance",
        component: MarkMyAttendance,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Mark My Attendance'
        },
        isPreventedRoute: false
    },
    {
        path: "/attendance-type-configuration",
        name: "AttendanceTypeConfiguration",
        component: AttendanceTypeConfiguration,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | AttendanceTypeConfiguration'
        },
        isPreventedRoute: false
    },
    {
        path: "/attendance-report",
        name: "AttendanceReport",
        component: AttendanceReport,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Attendance Report'
        },
        isPreventedRoute: false
    },
    {
        path: "/exam-report",
        name: "ExamReport",
        component: ExamReport,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | Exam Report'
        },
        isPreventedRoute: false
    },
    {
        path: "/user-access-management",
        name: "UserAccessManagement",
        component: UserAccessManagement,
        icon: "",
        invisible: false,
        meta: {
            title: 'Dunes College Kutch | User Access Management'
        },
        isPreventedRoute: false
    },
]

export default dashRoutes;